import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { UserWalletComponent } from './user-wallet/user-wallet.component';
import { TablesComponent } from './tables/tables.component';
import { SettingsComponent } from './settings/settings.component';
import { MapsComponent } from './maps/maps.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { UserLayoutRoutes } from './user-layout.routing';
import { MessageComponent } from './message/message.component';
import { ChatComponent } from './chat/chat.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PatientProfileComponent } from './patient-profile/patient-profile.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { DoctorCalendarComponent } from './doctor-calendar/doctor-calendar.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { PersianDatePickerComponent } from "../../components/date-picker/persian-date-picker/persian-date-picker.component";
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TabViewModule } from 'primeng/tabview';
import { PaginatorModule } from 'primeng/paginator';
import { VisitLinkComponent } from '../visit/visit-link/visit-link.component';


@NgModule({
    imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    RouterModule.forChild(UserLayoutRoutes),
    TranslateModule,
    FormsModule,
    SharedModule,
    ImageCropperComponent,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule.setOpts('ar-AE', 'arab'),
    PersianDatePickerComponent,
    TabViewModule,
    PaginatorModule,
    ToastModule
],
    declarations: [
        UserWalletComponent,
        // TablesComponent,
        // SettingsComponent,
        // MapsComponent,
        DashboardComponent,
        AppointmentListComponent,
        AccountInfoComponent,
        MessageComponent,
        ChatComponent,
        PatientProfileComponent,
        DoctorCalendarComponent,
        VisitLinkComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: [
        MessageService
    ]
})

export class UserLayoutModule { }
